// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_tasting_image_kind */
var FoodTastingImageKind;
(function (FoodTastingImageKind) {
    FoodTastingImageKind["matte"] = "matte";
    FoodTastingImageKind["melt"] = "melt";
})(FoodTastingImageKind || (FoodTastingImageKind = {}));
;
export default FoodTastingImageKind;
/** Zod schema for food_tasting_image_kind */
export const foodTastingImageKind = z.nativeEnum(FoodTastingImageKind);
//# sourceMappingURL=FoodTastingImageKind.js.map